export const PROMOTED_GIGS_SUPPORTED_COUNTRY_CODES = [
    'af',
    'ax',
    'al',
    'as',
    'ad',
    'ai',
    'aq',
    'ag',
    'ar',
    'am',
    'aw',
    'au',
    'at',
    'az',
    'bs',
    'bh',
    'bb',
    'by',
    'be',
    'bz',
    'bm',
    'bt',
    'bo',
    'bq',
    'ba',
    'bv',
    'br',
    'io',
    'bn',
    'bg',
    'kh',
    'ca',
    'ky',
    'cl',
    'cn',
    'cx',
    'cc',
    'co',
    'ck',
    'cr',
    'hr',
    'cu',
    'cw',
    'cy',
    'cz',
    'dk',
    'dm',
    'do',
    'ec',
    'sv',
    'ee',
    'fk',
    'fo',
    'fj',
    'fi',
    'fr',
    'gf',
    'pf',
    'tf',
    'ge',
    'de',
    'gi',
    'gr',
    'gl',
    'gd',
    'gp',
    'gu',
    'gt',
    'gg',
    'gy',
    'ht',
    'hm',
    'va',
    'hn',
    'hk',
    'hu',
    'is',
    'id',
    'ir',
    'iq',
    'ie',
    'im',
    'il',
    'it',
    'jm',
    'jp',
    'je',
    'jo',
    'kz',
    'ki',
    'kr',
    'kp',
    'kw',
    'kg',
    'la',
    'lv',
    'lb',
    'li',
    'lt',
    'lu',
    'mo',
    'my',
    'mv',
    'mt',
    'mh',
    'mq',
    'mx',
    'fm',
    'md',
    'mc',
    'mn',
    'me',
    'ms',
    'mm',
    'nr',
    'np',
    'nl',
    'nc',
    'nz',
    'ni',
    'nu',
    'nf',
    'mk',
    'mp',
    'no',
    'om',
    'pw',
    'ps',
    'pa',
    'pg',
    'py',
    'pe',
    'ph',
    'pn',
    'pl',
    'pt',
    'pr',
    'qa',
    'ro',
    'ru',
    'bl',
    'kn',
    'lc',
    'mf',
    'pm',
    'vc',
    'ws',
    'sm',
    'sa',
    'rs',
    'sg',
    'sx',
    'sk',
    'si',
    'sb',
    'gs',
    'es',
    'lk',
    'sr',
    'sj',
    'se',
    'ch',
    'sy',
    'tw',
    'tj',
    'th',
    'tl',
    'tk',
    'to',
    'tt',
    'tr',
    'tm',
    'tc',
    'tv',
    'ua',
    'ae',
    'gb',
    'um',
    'us',
    'uy',
    'uz',
    'vu',
    've',
    'vn',
    'vg',
    'vi',
    'wf',
    'eh',
    'ye',
];
